import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui";
import {
  useCharacterStore,
  useNarrativeStore,
  useWorldStore,
} from "@/engine/state";
import { borrarTodo } from "@/engine/persistence";
import bgForest from "@/assets/images/backgrounds/placeholder-forest.svg";

export function MenuPage() {
  const navigate = useNavigate();
  const personaje = useCharacterStore((s) => s.personaje);
  const sceneIdActual = useNarrativeStore((s) => s.sceneIdActual);
  const reiniciarChar = useCharacterStore((s) => s.reiniciar);
  const reiniciarNarr = useNarrativeStore((s) => s.reiniciar);
  const reiniciarWorld = useWorldStore((s) => s.reiniciar);

  const tienePartidaEnCurso =
    sceneIdActual !== null || personaje.nivel > 1 || personaje.xp > 0;

  const nuevaPartida = () => {
    borrarTodo();
    reiniciarChar();
    reiniciarNarr();
    reiniciarWorld();
    navigate("/game/story");
  };

  const continuar = () => navigate("/game/story");

  return (
    <div className="relative h-full w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-60"
        style={{ backgroundImage: `url(${bgForest})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-vignette" aria-hidden />
      <div
        className="absolute inset-0 bg-gradient-to-b from-ash-950/40 via-transparent to-ash-950"
        aria-hidden
      />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-6"
      >
        <p className="fluid-xs uppercase tracking-[0.4em] text-ember-400/80 font-display mb-3">
          Una aventura del bosque
        </p>
        <h1 className="fluid-3xl text-display text-ash-50 tracking-[0.15em]">
          The Cappy Keeper Remake
        </h1>
        <p className="text-narrative italic text-ash-300 mt-4 max-w-xl fluid-base px-4">
          El incendio se comió todo. Pipo corrió al bosque.
          <br />
          Lo que queda es una historia que todavía no elegiste.
        </p>

        <div className="mt-8 md:mt-12 flex flex-col gap-3 w-full max-w-xs">
          {tienePartidaEnCurso && (
            <Button size="lg" onClick={continuar} variant="primary">
              Continuar
            </Button>
          )}
          <Button
            size="lg"
            onClick={nuevaPartida}
            variant={tienePartidaEnCurso ? "secondary" : "primary"}
          >
            Nueva partida
          </Button>
        </div>

        <p className="mt-8 fluid-xs text-ash-600 font-ui uppercase tracking-widest">
          v0.14 · DEMO
        </p>
      </motion.div>
    </div>
  );
}
